module.exports = __webpack_public_path__ + "img/switch-on.b49128b6.svg";